import { useEffect, useRef } from "react";
import { useMap } from "react-leaflet";

const isValidLatLng = (point) => {
  if (!Array.isArray(point) || point.length !== 2) return false;
  const [lat, lng] = point;
  return (
    typeof lat === "number" &&
    typeof lng === "number" &&
    !Number.isNaN(lat) &&
    !Number.isNaN(lng) &&
    lat >= -90 &&
    lat <= 90 &&
    lng >= -180 &&
    lng <= 180
  );
};

function AutoFitBounds({ locations = [], arcs = [] }) {
  const map = useMap();
  const prevBoundsKeyRef = useRef("");

  useEffect(() => {
    // Create a key based on IDs and coordinates to detect geometry changes
    // This ignores changes to other props like status/color/style
    const locationsKey = locations
      .map((l) => `${l.locationId}_${l.latitude}_${l.longitude}`)
      .sort()
      .join("|");

    const arcsKey = arcs
      .map((a) => {
        const fromStr = Array.isArray(a.from) ? a.from.join(",") : "null";
        const toStr = Array.isArray(a.to) ? a.to.join(",") : "null";
        return `${a.key}_${fromStr}_${toStr}`;
      })
      .sort()
      .join("|");

    const currentBoundsKey = `LOC:${locationsKey}::ARC:${arcsKey}`;

    // If geometry hasn't changed, skip fitting bounds
    if (prevBoundsKeyRef.current === currentBoundsKey) {
      return;
    }
    prevBoundsKeyRef.current = currentBoundsKey;

    const points = [];

    // Add valid location coordinates
    locations.forEach((loc) => {
      const point = [loc.latitude, loc.longitude];
      if (isValidLatLng(point)) points.push(point);
    });

    // Add valid arc coordinates
    arcs.forEach((arc) => {
      if (isValidLatLng(arc.from)) points.push(arc.from);
      if (isValidLatLng(arc.to)) points.push(arc.to);
    });

    if (points.length === 0) return; // nothing to fit

    try {
      map.fitBounds(points, { padding: [50, 50] });
    } catch (error) {
      // Optionally handle error without using console
      // For example, you could set an error state or ignore
    }
  }, [locations, arcs, map]);

  return null;
}

export default AutoFitBounds;
